import { render } from "./accident.vue?vue&type=template&id=5c6a18a2&scoped=true"
import script from "./accident.vue?vue&type=script&lang=js"
export * from "./accident.vue?vue&type=script&lang=js"

import "./accident.vue?vue&type=style&index=0&id=5c6a18a2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6a18a2"]])

export default __exports__